import './App.css';
import MainRoute from './MainRoutes/MainRoute';

function App() {
  return (
    <div>
     <MainRoute></MainRoute>
    </div>
  );
}

export default App;
